import apiClient from '../utils/apiClient';

export async function uploadCompanyLogo(file) {
  const formData = new FormData();
  formData.append("logo", file);

  const response = await apiClient.post('/api/auth/company-logo', formData);

  return response.data;
}

export async function updateCompanyCurrency(currency) {
  const response = await apiClient.put('/api/profile/company-currency', { currency });
  return response.data;
}

export async function getCompanyEmployeeVisibility() {
  const response = await apiClient.get('/api/profile/company-employee-visibility');
  return response.data;
}

export async function updateCompanyEmployeeVisibility(hiddenEmployeeIds = []) {
  const response = await apiClient.put('/api/profile/company-employee-visibility', {
    hiddenEmployeeIds,
  });
  return response.data;
}
